/*global angular */
/*jslint node: true */

'use strict';

var text = angular.module('text', []);

text.service('textSlot', ['$templateCache', function ($templateCache) {
    return {
        getTemplate: function () {
            return $templateCache.get('slots/text/text.html');
        }
    };
}]);
